var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBenefit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_5944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6 14.4C46.9255 14.4 48 13.3255 48 12V2.4C48 1.0745 46.9255 0 45.6 0H2.4C1.0745 0 0 1.0745 0 2.4V12C0 13.3255 1.0745 14.4 2.4 14.4H4.8V16.8H2.4C1.0745 16.8 0 17.8745 0 19.2V28.8C0 30.1255 1.0745 31.2 2.4 31.2H4.8V33.6H2.4C1.0745 33.6 0 34.6745 0 36V45.6C0 46.9255 1.0745 48 2.4 48H45.6C46.9255 48 48 46.9255 48 45.6V36C48 34.6745 46.9255 33.6 45.6 33.6H43.2V31.2H45.6C46.9255 31.2 48 30.1255 48 28.8V19.2C48 17.8745 46.9255 16.8 45.6 16.8H43.2V14.4H45.6ZM45.6 35.2C46.0418 35.2 46.4 35.5582 46.4 36V45.6C46.4 46.0418 46.0418 46.4 45.6 46.4H2.4C1.9582 46.4 1.6 46.0418 1.6 45.6V36C1.6 35.5582 1.9582 35.2 2.4 35.2H45.6ZM6.4 33.6V31.2H8V33.6H6.4ZM9.6 33.6V31.2H38.4V33.6H9.6ZM40 33.6V31.2H41.6V33.6H40ZM45.6 18.4C46.0418 18.4 46.4 18.7582 46.4 19.2V28.8C46.4 29.2418 46.0418 29.6 45.6 29.6H2.4C1.9582 29.6 1.6 29.2418 1.6 28.8V19.2C1.6 18.7582 1.9582 18.4 2.4 18.4H45.6ZM6.4 16.8V14.4H8V16.8H6.4ZM9.6 16.8V14.4H38.4V16.8H9.6ZM40 16.8V14.4H41.6V16.8H40ZM2.4 12.8C1.9582 12.8 1.6 12.4418 1.6 12V2.4C1.6 1.9582 1.9582 1.6 2.4 1.6H45.6C46.0418 1.6 46.4 1.9582 46.4 2.4V12C46.4 12.4418 46.0418 12.8 45.6 12.8H2.4Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 6.39996H9.45282C9.01102 5.15026 7.63972 4.49536 6.39012 4.93726C5.14052 5.37916 4.48552 6.75026 4.92732 7.99996C5.36912 9.24966 6.74042 9.90456 7.99002 9.46266C8.67352 9.22106 9.21122 8.68346 9.45282 7.99996H25.6C26.0418 7.99996 26.4 7.64176 26.4 7.19996C26.4 6.75816 26.0418 6.39996 25.6 6.39996ZM7.20002 7.99996C6.75822 7.99996 6.40002 7.64176 6.40002 7.19996C6.40002 6.75816 6.75822 6.39996 7.20002 6.39996C7.64182 6.39996 8.00002 6.75816 8.00002 7.19996C8.00002 7.64176 7.64182 7.99996 7.20002 7.99996Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 3.19995H35.2V4.79995H36.8V3.19995Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 3.19995H38.4V4.79995H40V3.19995Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 3.19995H41.6V4.79995H43.2V3.19995Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 3.19995H32V4.79995H33.6V3.19995Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 3.19995H28.8V4.79995H30.4V3.19995Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 6.3999H35.2V7.9999H36.8V6.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 6.3999H38.4V7.9999H40V6.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 6.3999H41.6V7.9999H43.2V6.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 6.3999H32V7.9999H33.6V6.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 6.3999H28.8V7.9999H30.4V6.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 9.6001H35.2V11.2001H36.8V9.6001Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 9.6001H38.4V11.2001H40V9.6001Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 9.6001H41.6V11.2001H43.2V9.6001Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 9.6001H32V11.2001H33.6V9.6001Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 9.6001H28.8V11.2001H30.4V9.6001Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 23.2H9.45282C9.01102 21.9503 7.63972 21.2954 6.39012 21.7373C5.14052 22.1792 4.48552 23.5503 4.92732 24.8C5.36912 26.0497 6.74042 26.7046 7.99002 26.2627C8.67352 26.0211 9.21112 25.4834 9.45272 24.8H25.6C26.0418 24.8 26.4 24.4418 26.4 24C26.4 23.5582 26.0418 23.2 25.6 23.2ZM7.20002 24.8C6.75822 24.8 6.40002 24.4418 6.40002 24C6.40002 23.5582 6.75822 23.2 7.20002 23.2C7.64182 23.2 8.00002 23.5582 8.00002 24C8.00002 24.4418 7.64182 24.8 7.20002 24.8Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 20H35.2V21.6H36.8V20Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20H38.4V21.6H40V20Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 20H41.6V21.6H43.2V20Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 20H32V21.6H33.6V20Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 20H28.8V21.6H30.4V20Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 23.2H35.2V24.8H36.8V23.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 23.2H38.4V24.8H40V23.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 23.2H41.6V24.8H43.2V23.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 23.2H32V24.8H33.6V23.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 23.2H28.8V24.8H30.4V23.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 26.3999H35.2V27.9999H36.8V26.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26.3999H38.4V27.9999H40V26.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 26.3999H41.6V27.9999H43.2V26.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 26.3999H32V27.9999H33.6V26.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 26.3999H28.8V27.9999H30.4V26.3999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 40.0001H9.45282C9.01102 38.7504 7.63972 38.0955 6.39012 38.5374C5.14052 38.9793 4.48552 40.3504 4.92732 41.6001C5.36912 42.8498 6.74042 43.5047 7.99002 43.0628C8.67352 42.8212 9.21112 42.2835 9.45272 41.6001H25.6C26.0418 41.6001 26.4 41.2419 26.4 40.8001C26.4 40.3583 26.0418 40.0001 25.6 40.0001ZM7.20002 41.6001C6.75822 41.6001 6.40002 41.2419 6.40002 40.8001C6.40002 40.3583 6.75822 40.0001 7.20002 40.0001C7.64182 40.0001 8.00002 40.3583 8.00002 40.8001C8.00002 41.2419 7.64182 41.6001 7.20002 41.6001Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 36.8H35.2V38.4H36.8V36.8Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 36.8H38.4V38.4H40V36.8Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 36.8H41.6V38.4H43.2V36.8Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 36.8H32V38.4H33.6V36.8Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 36.8H28.8V38.4H30.4V36.8Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 40H35.2V41.6H36.8V40Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 40H38.4V41.6H40V40Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 40H41.6V41.6H43.2V40Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 40H32V41.6H33.6V40Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 40H28.8V41.6H30.4V40Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 43.2H35.2V44.8H36.8V43.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 43.2H38.4V44.8H40V43.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 43.2H41.6V44.8H43.2V43.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 43.2H32V44.8H33.6V43.2Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 43.2H28.8V44.8H30.4V43.2Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_5944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#101010"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefit1);
export default __webpack_public_path__ + "static/media/iconBenefit1.dc39999de6071ffefcf76559ce1ace36.svg";
export { ForwardRef as ReactComponent };